import { useState } from 'react';
import InputField from '../../../../../components/molecules/InputField';
import NodeSettingAccordion from './NodeSettingAccordion';
import NodeSettings from '.';
import FormControlSelect from '../../../../../components/molecules/FormControl/FormControlSelect';
import { buildUrl } from '../../../../../helpers/utils';
import { urls } from '../../../_rego.config';

const NodeTaskConfig = ({ config }) => {
    const [selectedForm, setSelectedForm] = useState(0);
    return (
        <div>
            <NodeSettingAccordion
                icon='bi-table'
                title='Parameters'
                visible={true}>
                {config?.params &&
                    Object.entries(config?.params)?.map(([key, value], index) => {
                        return (
                            <div className='mt-2'>
                                <div className='input-group d-flex'>
                                    <InputField
                                        defaultValue={key}
                                        config={{
                                            name: 'key',
                                            placeholder: 'Key',
                                            className: 'form-control-xs',
                                        }}
                                    />
                                    <InputField
                                        defaultValue={value}
                                        config={{
                                            name: 'value',
                                            placeholder: 'Value',
                                            className: 'form-control-xs',
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                <div className='d-flex justify-content-center py-2'>
                    <i className='bi bi-plus-lg'></i>
                </div>
            </NodeSettingAccordion>
            {config.name === 'generate_pdf' && (
                <NodeSettingAccordion
                    icon='bi-file-pdf'
                    title='Generate PDF Configuration'>
                    <h5 className='mt-3 fs-8'>Template ID</h5>
                    <InputField
                        defaultValue={config?.template_id}
                        config={{
                            name: 'template_id',
                            placeholder: 'Template ID',
                            className: 'form-control-xs mt-3',
                        }}
                    />
                    <h5 className='mt-3 fs-8'>Vendor</h5>
                    <InputField
                        defaultValue={config?.vendor}
                        config={{
                            name: 'vendor',
                            placeholder: 'Vendor',
                            className: 'form-control-xs mt-3',
                        }}
                    />
                </NodeSettingAccordion>
            )}
        </div>
    );
};
export default NodeTaskConfig;
